import * as Sentry from '@sentry/react';
import { logger } from 'helpers/logger';
import { sentryDSN, sentryEnvironment, sentryRelease } from 'config/constants';

const initializeSentry = () => {
  if (sentryDSN) {
    Sentry.init({
      release: sentryRelease,
      dsn: sentryDSN,
      integrations: [Sentry.browserTracingIntegration()],
      environment: sentryEnvironment,

      tracesSampleRate: 1.0,
    });
  }
};

const captureException = (
  error: Error,
  captureContext?: Parameters<typeof Sentry.captureException>[1],
) => {
  logger.error(error);
  if (sentryDSN) {
    Sentry.captureException(error, captureContext);
  }
};

export { initializeSentry, captureException };
